/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, State } from '../redux';

const initialState: State['user'] = {
  id: '',
  principalId: '',
  permissions: [],
  fullName: '',
};

export function userReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
